var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Nav'),_c('v-main',[_c('v-progress-linear',{attrs:{"active":_vm.loading,"indeterminate":"","fixed":""}}),_c('Intro'),_c('v-container',[_c('Main')],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }